export const shouldRemoveOrderFromDatasource = ({
	currentOrderTargetId,
	newOrderTargetId,
	cleanElementView,
}) =>
	currentOrderTargetId !== newOrderTargetId &&
	typeof cleanElementView === 'function';
